import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

export type NumberedListItem = {
  title: string;
  description?: string;
  id?: string;
};

export type NumberedListProps = {
  items: NumberedListItem[];
  className?: string;
  itemClassName?: string;
  numberClassName?: string;
  contentClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  startNumber?: number;
};

export const NumberedList = ({
  items,
  className,
  itemClassName,
  numberClassName,
  contentClassName,
  titleClassName,
  descriptionClassName,
  startNumber = 1,
}: NumberedListProps) => {
  if (!items.length) {
    return null;
  }

  return (
    <div className={cnTwMerge("flex flex-col", className)}>
      {items.map((item, index) => {
        const number = startNumber + index;

        return (
          <div
            className={cnTwMerge("flex items-start gap-4 py-3", itemClassName)}
            key={item.id || `numbered-item-${index}`}
          >
            <div
              className={cnTwMerge(
                "flex-shrink-0 w-6 h-6 bg-background/secondary rounded-full flex items-center justify-center body-small-regular text-text/primary",
                numberClassName,
              )}
            >
              {number}
            </div>
            <div className={cnTwMerge("flex-1 min-w-0", contentClassName)}>
              <h3
                className={cnTwMerge(
                  "body-base-medium text-text/primary mb-1",
                  titleClassName,
                )}
              >
                {item.title}
              </h3>
              {item.description ? (
                <p
                  className={cnTwMerge(
                    "body-small-regular text-text/secondary",
                    descriptionClassName,
                  )}
                >
                  {item.description}
                </p>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
};
